module.exports = __webpack_public_path__ + "img/demo-interior-design.c56a432e.jpg";